module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17915/js/img/valuePropModals/ReportBuilder/ValueProp2.svg"